import { AutocompleteInput, BooleanField, BooleanInput, BulkUpdateButton, Create, Datagrid, DateInput,required, Edit, EditButton,ShowButton, List, NumberField, NumberInput, ReferenceField, ReferenceInput, SelectInput, Show, SimpleForm, SimpleShowLayout, TextField, TextInput, DateField, useRecordContext, Toolbar, useNotify, SaveButton } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

const PostBulkActionButtons = () => (
    <>
    <BulkUpdateButton label="Approve" icon={false} source="approved" data={{approved: true}} />
    <BulkUpdateButton label="Deny" icon={false} source="approved"  data={{approved: false}}/>
    </>
);
const ReimTypeFilter = () => {
    var company = useWatch({ name: 'company_id' });
    if (company == null || company === '') {
        company = 99;
    }
    return (
        <ReferenceInput source="reimbursable_type_id" reference="reimbursable_type" validate={required()} filter={{ company_id: company}} ><SelectInput source="name" /></ReferenceInput>
    );
};

const reimbursementFilter = [
    <ReferenceInput source="company_id" reference="companies" validate={required()} alwaysOn><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>,
    <ReimTypeFilter alwaysOn/>,
    <TextInput source="invoice_no" alwaysOn/>,
    <BooleanInput source="approved" defaultValue={true}/>,
    <ReferenceInput source="reimbursable_report_id" reference="reimbursable_report"><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
];

export const ReimbursementListSA = () => (
    <List filters={reimbursementFilter}>
        <Datagrid bulkActionButtons={<PostBulkActionButtons />}>
            <TextField source="id" />
            <ReferenceField source="reimbursable_type_id" reference="reimbursable_type"><TextField source="name" /></ReferenceField>
            <TextField source="invoice_no" />
            <DateField source="invoice_date" locales='en-IN'/>
            <NumberField source="amount" />
            <NumberField source="amount_gst" label="GST Amount" />
            <NumberField source="total_amount" label="Total  Amount" />
            <ReferenceField label="Currency" source="reimbursable_type_id" reference="reimbursable_type"><TextField source="currency" /></ReferenceField>
            <BooleanField source="approved" />
            <ReferenceField source="reimbursable_report_id" reference="reimbursable_report"><TextField source="name" /></ReferenceField>
            <ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <ShowButton label="View" />
            <EditButton label="Edit" />
        </Datagrid>
    </List>
);

export const ReimbursementList = () => (
    <List filters={reimbursementFilter}>
        <Datagrid>
            <TextField source="id" />
            <ReferenceField source="reimbursable_type_id" reference="reimbursable_type"><TextField source="name" /></ReferenceField>
            <TextField source="invoice_no" />
            <DateField source="invoice_date" locales='en-IN'/>
            <NumberField source="amount" />
            <NumberField source="amount_gst" label="GST Amount" />
            <NumberField source="total_amount" label="Total  Amount" />
            <ReferenceField label="Currency" source="reimbursable_type_id" reference="reimbursable_type"><TextField source="currency" /></ReferenceField>
            <BooleanField source="approved" />
            <ReferenceField source="reimbursable_report_id" reference="reimbursable_report"><TextField source="name" /></ReferenceField>
            <ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <ShowButton label="View" />
            <EditButton label="Edit" />
        </Datagrid>
    </List>
);

export const ReimbursementShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <ReferenceField source="reimbursable_type_id" reference="reimbursable_type"><TextField source="name" /></ReferenceField>
            <ReferenceField label="Currency" source="reimbursable_type_id" reference="reimbursable_type"><TextField source="currency" /></ReferenceField>
            <NumberField source="amount" />
            <NumberField source="amount_gst" label="GST Amount" />
            <NumberField source="total_amount" label="Total Amount" />
            <BooleanField source="approved" />
            <ReferenceField source="reimbursable_report_id" reference="reimbursable_report"><TextField source="name" /></ReferenceField>
            <ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <TextField source="invoice_no" />
            <DateField source="invoice_date" locales='en-IN' />
            <TextField source="vendor"  label="Vendor Name" fullWidth/>
            <TextField source="product_description" fullWidth />
            <TextField source="comments" fullWidth multiline />
        </SimpleShowLayout>
    </Show>
);

const ReimbursementUpdation = () => {
    const record = useRecordContext();
    return record.approved ?? false ? <ReimbursementShow /> : <SimpleForm>
    <ReferenceField source="reimbursable_type_id" reference="reimbursable_type"><TextField source="name" /></ReferenceField>
    Company:<ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
    Approved: <BooleanField label="Approved" source="approved" />
    <TextInput source="name" fullWidth multiline />
    <NumberInput source="quantity" onWheel={e => e.target.blur()} />
    <NumberInput source="amount" onWheel={e => e.target.blur()}  />
    <NumberInput source="amount_gst" label="GST" onWheel={e => e.target.blur()}  />
    <NumberInput source="total_amount" label="Total Amount" onWheel={e => e.target.blur()}  />
    <TextInput source="invoice_no" />
    <DateInput source="invoice_date" />
    <TextInput source="vendor"  label="Vendor Name" fullWidth/>
    <TextInput source="product_description" fullWidth />
    <TextInput source="comments" fullWidth multiline />
</SimpleForm>
};

export const ReimbursementEdit = () => (
    <Edit>
        <ReimbursementUpdation />
    </Edit>
    );

export const ReimbursementEditSA = () => (
    <Edit>
        <SimpleForm>
            <ReferenceField source="reimbursable_type_id" reference="reimbursable_type"><TextField source="name" /></ReferenceField>
            Company:<ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <ReimbursableTypeInput fullWidth />
            <BooleanInput source="approved" />
            <TextInput source="name" fullWidth multiline />
            <NumberInput source="quantity" onWheel={e => e.target.blur()}  />
            <NumberInput source="amount" onWheel={e => e.target.blur()}  />
            <NumberInput source="amount_gst" label="GST" onWheel={e => e.target.blur()}  />
            <NumberInput source="total_amount" label="Total Amount" onWheel={e => e.target.blur()}  />
            <TextInput source="invoice_no" />
            <DateInput source="invoice_date" />
            <TextInput source="vendor"  label="Vendor Name" fullWidth/>
            <TextInput source="product_description" fullWidth />
            <TextInput source="comments" fullWidth multiline />
        </SimpleForm>
    </Edit>
);

const ReimbursableTypeInput = props => {
    var company = useWatch({ name: 'company_id' });
    var currency = useWatch({name: 'currency'});
    // const values = getValues();
    if (company == null || company === '') {
        company = 99;
    }
    return (
        <ReferenceInput source="reimbursable_type_id" reference="reimbursable_type" fullWidth="true" filter={{ company_id: company, currency:currency,active: true }}><AutocompleteInput source="name" fullWidth /></ReferenceInput>
    );
};

const CompanyTypeInput = props => {
    var company = useWatch({ name: 'parent_company_id' });
    // const values = getValues();
    if (company == null || company === '') {
        company = 99;
    }
    return (
        <ReferenceInput source="company_id" reference="companies" filter={{ parent_company_id: company }}><SelectInput source="name" /></ReferenceInput>
    );
};

const CustomCreateToolbar = () =>{
    const { reset } = useFormContext();
    const notify = useNotify();
    return (
        <Toolbar>
            <SaveButton label="Save" />
            <SaveButton 
                label="Save and add"
                mutationOptions={{
                    onSuccess: () => {
                        notify('Element created');
                        reset();
                    }}
                }
                type="button"
                variant="text"
            />
        </Toolbar>
    );
};

export const ReimbursementCreate = () => (
    <Create>
        <SimpleForm toolbar={<CustomCreateToolbar />}>
            <ReferenceInput source="parent_company_id" reference="parent_companies"><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
            <CompanyTypeInput />
            <SelectInput source="currency" choices={[
                    { id: 'INR', name: 'INR' },
                    { id: 'USD', name: 'USD' },
                    { id: 'JPY', name: 'JPY' },
                ]} />
            <ReimbursableTypeInput fullWidth />
            <TextInput source="name" fullWidth multiline />
            <NumberInput source="quantity" onWheel={e => e.target.blur()}  />
            <NumberInput source="amount" onWheel={e => e.target.blur()}  />
            <NumberInput source="amount_gst" label="GST" onWheel={e => e.target.blur()}  />
            <NumberInput source="total_amount" label="Total Amount" onWheel={e => e.target.blur()} />
            <TextInput source="invoice_no" />
            <DateInput source="invoice_date" />
            <TextInput source="vendor" />
            <TextInput source="product_description" fullWidth />
            <TextInput source="comments" fullWidth multiline />
        </SimpleForm>
    </Create>
);
